/**********************************************************
Hawaiian Macadamia Nut Services
Alexander Self
7/17/20
Engine table component: called in irrigation_create
**********************************************************/
import { sumProp } from '../irrigation_utils';
import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  engines: PropTypes.array,
  engineLog: PropTypes.array
};

const EngineTable = ({ engines, engineLog }) => {
  return (
    <div className="irr-log-table">
      <table className="responsive-table bordered highlight centered">
        <thead>
          <tr>
            <th>Engine</th>
            <th>Hours</th>
            <th>Fuel (gal)</th>
          </tr>
        </thead>
        <tbody>
          { 
            engineLog.map((e) => {
              let engine = engines.find((_e) => _e.id === e.engineId);
              return (
                <tr key={e.engineId}>
                  <td>{ engine === undefined ? '' : engine.name }</td>
                  <td>{ e.hours }</td>
                  <td>{ e.totalFuelGal }</td>
                </tr>
              )
            })
          }
        </tbody>
        <tfoot className="hide-on-med-and-down">
          <tr>
            <td><center>Totals</center></td>
            <td><center><b>{ engineLog.length > 0 ? sumProp('hours', engineLog): 0 }</b></center></td>
            <td><center><b>{ engineLog.length > 0 ? sumProp('totalFuelGal', engineLog): 0 }</b></center></td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
}


EngineTable.propTypes = propTypes;
export default EngineTable;



/* END */



// WEBPACK FOOTER //
// ./src/irrigation/components/engine_table.js